import { cacheInvalidate, cacheWriteEntry } from '../actions';

const initialState = {
  entries: {},
};

export const cacheReducer = (state = initialState, action) => {
  switch (action.type) {
    case cacheWriteEntry: {
      const { key, data, ttlMs, updatedAt } = action.payload || {};
      if (!key) return state;
      const nextEntry = {
        data,
        ttlMs: Number.isFinite(ttlMs) ? ttlMs : state.entries[key]?.ttlMs,
        updatedAt: updatedAt || Date.now(),
      };
      return {
        ...state,
        entries: {
          ...state.entries,
          [key]: nextEntry,
        },
      };
    }
    case cacheInvalidate: {
      const { key, exact } = action.payload || {};
      if (!key) return state;
      const entries = { ...state.entries };
      Object.keys(entries).forEach((entryKey) => {
        const matches = exact ? entryKey === key : entryKey.startsWith(key);
        if (matches) {
          delete entries[entryKey];
        }
      });
      return {
        ...state,
        entries,
      };
    }
    default:
      return state;
  }
};

export default cacheReducer;
